/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BountyResponseDtoFromJSON, BountyResponseDtoToJSON, } from './BountyResponseDto';
/**
 * Check if a given object implements the BountyResponseDtoPageResponse interface.
 */
export function instanceOfBountyResponseDtoPageResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function BountyResponseDtoPageResponseFromJSON(json) {
    return BountyResponseDtoPageResponseFromJSONTyped(json, false);
}
export function BountyResponseDtoPageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': !exists(json, 'count') ? undefined : json['count'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(BountyResponseDtoFromJSON)),
    };
}
export function BountyResponseDtoPageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'totalCount': value.totalCount,
        'page': value.page,
        'pageSize': value.pageSize,
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(BountyResponseDtoToJSON)),
    };
}
